// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import "../static/common/common.css"
import ElementUI from 'element-ui'
import "element-ui/lib/theme-chalk/index.css"
import "./assets/icon/iconfont.css"
import axios from 'axios'
import global from './components/Global'//引用文件
//引入echarts
import echarts from 'echarts'
//配置api步骤一
import { httpGet, httpPost } from './api/config'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI);

//配置api步骤二
Vue.prototype.$httpGet = httpGet
Vue.prototype.$httpPost = httpPost
//引入echarts
Vue.prototype.$echarts = echarts
//配置api步骤三
//Vue.prototype.axios = axios
//Vue.prototype.GLOBAL = global//挂载到Vue实例上面
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  //console.log(to)
  if (to.meta.title) {
    document.title = " SAAS后台管理_" + to.meta.title
  }
  if (to.matched.some((route) => route.meta.requireAuth)) {
    // console.log("跳转" + localStorage.getItem('token'))
    if (getItemWithExpiration('_admintoken_')) {
      next()
    } else {
      next({
        path: '/',
        query: {
          returnURL: to.path
        }
      })
    }

  } else {
    //console.log("跳转2" + localStorage.getItem('token'))
    next()
  }
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


function getItemWithExpiration(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiration) {
        // 数据已过期，删除并返回null
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}



// WEBPACK FOOTER //
// ./src/main.js